module.exports = __webpack_public_path__ + "3aabd0ea6d0ec3e789eeea16d862d52d.png";